














import {Component, Vue, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Meta } from '@sophosoft/vue-meta-decorator'
import CurrentShardList from '@/components/lfs/NewShardList/CurrentShardList.vue'
import ArchiveShardList from '@/components/lfs/NewShardList/ArchiveShardList.vue'

const auth = namespace('auth')
const profile = namespace('profile')
const shards = namespace('shards')
const event = namespace('event')
const roistat = namespace('roistat')


@Component({
  components: {
    CurrentShardList,
    ArchiveShardList
  }
})
export default class NewShardList extends Vue {
  @Meta
  getMetaInfo () {
    return {
      title: `LeadFrog - ${ this.$t('shardList.title') }`
    }
  }

  protected pageLoading: boolean = true

  @auth.State('exhibitorId') protected _exhibitor: any
  @profile.Getter('plan') protected plan: any
  @event.State('eventId') protected eventId!: string

  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any

  
  tab = null


}
